import axios from "@/libs/api.request";
import { getToken } from "@/libs/util";
// 获取列表
export const getShipment = data => {
  return axios.request({
    url: "/finance/hq/outbound/index",
    method: "post",
    data
  });
};

export const getAllCosting = data => {
  return axios.request({
    url: "/finance/hq/outbound/index?types=Costing",
    method: "post",
    data
  });
};

export const getAllOverSeaCosting = data => {
  return axios.request({
    url: "/finance/hq/outbound/index?types=OverSeaCosting",
    method: "post",
    data
  });
};

export const getShipmentCosting = data => {
  return axios.request({
    url: "/finance/hq/outbound/index?department=x1",
    method: "post",
    data
  });
};

// 重新计算运费
export const refShipments = data => {
  return axios.request({
    url: "/finance/hq/outbound/recalculate",
    method: "post",
    data
  });
};

export const exportOutBound = data => {
  return axios.request({
    url: "/finance/orderfinance/exportOutBound",
    method: "post",
    data
  });
};

export const getTags = () => {
  return axios.request({
    url: "/finance/orderfinance/tags",
    method: "get"
  });
};

export const createBill = data => {
  return axios.request({
    url: "/finance/hq/outbound/createBill",
    method: "post",
    data
  });
};

export const cancelHang = data => {
  return axios.request({
    url: "/finance/hq/outbound/cancelAbnormal",
    method: "post",
    data
  });
};

export const uploadFile = data => {
  return axios.request({
    url: "/finance/orderfinance/updateWeightFinance",
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken()
    },
    data: data
  });
};

export const getConfig = () => {
  return axios.request({
    url: "/finance/OrderFinance/config",
    method: "get"
  });
};

export const client = data => {
  return axios.request({
    url: "/finance/orderfinance",
    method: "post",
    data
  });
};

export const client_hq = data => {
  return axios.request({
    url: "/finance/hq/outbound/client",
    method: "get",
    data
  });
};


export const branchOffice = data => {
  return axios.request({
    url: "/finance/branch/outbound",
    method: "post",
    data
  });
};

export const sync = data => {
  return axios.request({
    url: "/finance/hq/outbound/sync",
    method: "get",
    data
  });
};

export const setJiYun = data => {
  return axios.request({
    url: "/finance/hq/outbound/setJiYun",
    method: "post",
    data
  });
};

export const updateWeightFinance = data => {
  return axios.request({
    url: "/finance/hq/outbound/updateWeightFinance",
    method: "post",
    data
  });
};

export const newGetList=(data)=>{
	return axios.request({
		url:'/finance/hq/outbound/list/2',
		method:'post',
		data
	})
}





